<app-education-history-list [workerId]="workerId" [isLoggedUserProfile]="isLoggedUserProfile" [workerFormContext]="false"></app-education-history-list>
